import React from 'react';
import { getTextRenderMetrics } from '@/lib/labelTextFit';
import QrCodeBlock from '@/components/haccp/QrCodeBlock';

export default function PrintableLabel({ layout, data, className = '' }) {
  if (!layout) return null;
  const width = Number(layout.width_mm || 60);
  const height = Number(layout.height_mm || 40);
  return (
    <div className={`printable-label relative bg-white overflow-hidden ${className}`} style={{ width: `${width}mm`, height: `${height}mm` }}>
      {(layout.elements || []).map((el) => {
        if (el.type === 'line' || el.type === 'rectangle') {
          const style = { position: 'absolute', left: `${el.x_mm || 0}mm`, top: `${el.y_mm || 0}mm`, width: `${el.w_mm || 0}mm`, height: el.type === 'line' ? 0 : `${el.h_mm || 0}mm`, border: `${el.stroke_width || 1}mm solid black`, borderWidth: el.type === 'line' ? `${el.stroke_width || 1}mm 0 0` : undefined, boxSizing: 'border-box' };
          return <div key={el.id} style={style}/>;
        }
        if (el.type === 'qr') {
          const qrStyle = {
            position: 'absolute', left: `${el.x_mm || 0}mm`, top: `${el.y_mm || 0}mm`,
            width: `${el.w_mm || 12}mm`, height: `${el.h_mm || 12}mm`, overflow: 'hidden',
          };
          return <QrCodeBlock key={el.id} value={data?.[el.field || 'qr_payload']} style={qrStyle} />;
        }

        if (el.type === 'image' && el.content) {
          const imageStyle = {
            position: 'absolute', left: `${el.x_mm || 0}mm`, top: `${el.y_mm || 0}mm`,
            width: `${el.w_mm || 20}mm`, height: `${el.h_mm || 3}mm`, overflow: 'hidden',
          };
          return <div key={el.id} style={imageStyle}><img src={el.content} alt="" style={{ width:'100%', height:'100%', objectFit:'contain' }}/></div>;
        }

        const text = el.type === 'dynamic' ? (data?.[el.field] || '') : (el.content || '');
        const metrics = getTextRenderMetrics(el, text, width);
        const style = {
          position: 'absolute', left: `${el.x_mm || 0}mm`, top: `${el.y_mm || 0}mm`,
          width: `${metrics.widthMm}mm`, height: `${el.h_mm || 3}mm`,
          fontSize: `${metrics.fontSizePt}pt`, fontWeight: el.bold ? 700 : 400,
          textAlign: el.align || 'left', color: el.color === 'red' ? '#dc2626' : '#000',
          display: 'flex', alignItems: 'center',
          justifyContent: el.align === 'center' ? 'center' : el.align === 'right' ? 'flex-end' : 'flex-start',
          overflow: 'hidden', lineHeight: 1.05,
        };
        return <div key={el.id} style={style}><span style={{ whiteSpace: 'nowrap', width: '100%' }}>{text}</span></div>;
      })}
    </div>
  );
}
